import { formatNumberWithCommas } from './formatters';

type ExportOverLimitMessageParams = {
  maxClients: number;
  hasFilters?: boolean;
};

type DashboardSelectionLabelParams = {
  selectedCount: number;
  total: number;
  allOnPageSelected: boolean;
  isEverythingSelected: boolean;
};

type ModalSelectionLabelParams = {
  selectedCount: number;
  total: number;
  isAllSelected: boolean;
};

const selectedCount = (count: number): string =>
  count === 1 ? '1 client selected' : `${formatNumberWithCommas(count)} clients selected`;

const allSelected = (total: number): string => `All ${formatNumberWithCommas(total)} clients are selected`;

const selectAll = (total: number): string => `Select all ${formatNumberWithCommas(total)} clients`;

const exportOverLimit = ({ maxClients, hasFilters = true }: ExportOverLimitMessageParams): string => {
  const narrowHint = hasFilters ? 'Narrow your search or filters' : 'Narrow your search';
  return `You can export up to ${formatNumberWithCommas(maxClients)} clients at once. ${narrowHint}, or select fewer clients to export.`;
};

const dashboard = ({
  selectedCount: count,
  total,
  allOnPageSelected,
  isEverythingSelected,
}: DashboardSelectionLabelParams): string => {
  if (isEverythingSelected) return allSelected(total);
  if (allOnPageSelected) return 'All clients on this page are selected';
  return selectedCount(count);
};

const modal = ({ selectedCount: count, total, isAllSelected }: ModalSelectionLabelParams): string =>
  isAllSelected ? allSelected(total) : selectedCount(count);

export const clientSelectionLabels = {
  selectedCount,
  allSelected,
  selectAll,
  exportOverLimit,
  dashboard,
  modal,
} as const;
